module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/json-loader!./.cache/json/layouts-split.json
// module id = 1072
// module chunks = 40228349930423